import { ThemeContext } from "../../Contexts/ThemeContext";
import useScroll from "../../Hooks/useScroll";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Haircare = ({showIcon}) => {
  const [linkTwoHover, setLinkTwoHover] = useState(false);
  const [scrollPosition] = useScroll();

  return (
    <div
      onMouseEnter={() => {
        setLinkTwoHover(true);
        showIcon();
      }}
      onMouseLeave={() => setLinkTwoHover(false)}
      className={`transition-all ease-in-out duration-300 min-h-[50px] flex items-center ${
        scrollPosition > 80 ? "min-h-[65px]" : "min-h-[50px]"
      }`}
    >
      <p
        className={`mr-10 block font-bold cursor-pointer ${
          scrollPosition > 80
            ? "hover:text-accent text-secondary"
            : "text-secondary hover:text-accent"
        }`}
      >
        HAIRCARE
        <FontAwesomeIcon
          className="w-3 ms-2"
          icon={faChevronDown}
        ></FontAwesomeIcon>
      </p>
      <div
        className={`flex flex-col md:flex-row  absolute top-10 bg-white w-fit h-[100vh] md:h-auto md:ml-[-200px] ${
          linkTwoHover ? "block text-start" : "hidden relative"
        } text-black `}
      >
        {/* ........HAIR CLEANSER......... */}
        <div className="px-10 py-10 pt-16 md:py-16">
          <p className="mb-6 text-black text-opacity-70">HAIR CLEANSER</p>
          <Link
            to="/product-category/shampoo"
            className=" hover:text-accent block"
          >
            Shampoo
          </Link>
          <Link
            to="/product-category/conditioner"
            className=" hover:text-accent block"
          >
            Conditioner
          </Link>
          <Link
            to="/product-category/hair mask"
            className=" hover:text-accent block"
          >
            Hair Masks
          </Link>

          <Link
            to="/product-category/hair serum"
            className=" hover:text-accent block"
          >
            Hair Serum
          </Link>
        </div>

        {/* ........Hair Care......... */}
        <div className="px-10 py-10 md:py-16 pb-[120px]">
          <p className="mb-6 text-black text-opacity-70">HAIR CARE</p>
          <Link
            to={`/product-category/hair oil`}
            className=" hover:text-accent block"
          >
            Hair Oil
          </Link>

          <Link
            to={`/product-category/cleansing tonic`}
            className=" hover:text-accent block"
          >
            Cleansing Toner
          </Link>
        </div>
       
      </div>
    </div>
  );
};

export default Haircare;
